const googleConfig = {
  clientID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
};

export default googleConfig;
